import React from "react";
import { Link, useLocation, useNavigate, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../lib/AuthContext";
import { LayoutDashboard, FileText, PlusCircle, Inbox, Lightbulb, Rss, LogOut, ExternalLink, Image, UserCog } from "lucide-react";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/articles", label: "Articles", icon: FileText },
  { to: "/admin/articles/new", label: "New Article", icon: PlusCircle },
  { to: "/admin/review", label: "Review Queue", icon: Inbox },
  { to: "/admin/tips", label: "News Tips", icon: Lightbulb },
  { to: "/admin/feeds", label: "Auto Feeds", icon: Rss },
  { to: "/admin/media", label: "Media Library", icon: Image },
  { to: "/admin/profile", label: "Profile", icon: UserCog },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const navigate = useNavigate();

  if (user === null) return <div className="min-h-screen bg-r24-black flex items-center justify-center text-white">Loading…</div>;
  if (user === false) return <Navigate to="/admin/login" replace />;

  const isActive = (item) => item.end ? loc.pathname === item.to : loc.pathname.startsWith(item.to) && item.to !== "/admin";

  return (
    <div className="min-h-screen flex bg-gray-100">
      <aside className="w-60 bg-r24-black text-white flex flex-col fixed h-full">
        <div className="p-5 flex items-center gap-3 border-b border-white/10">
          <img src="/brand/logo.jpg" alt="" className="h-9 w-9 rounded-full object-cover ring-1 ring-r24-red" />
          <div className="font-head font-bold">RAPID<span className="text-r24-red">24</span></div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map((item) => {
            const Icon = item.icon;
            return (
              <Link key={item.to} to={item.to} data-testid={`admin-nav-${item.label.toLowerCase().replace(/ /g, "-")}`}
                className={`flex items-center gap-3 px-3 py-2.5 font-head font-semibold text-sm uc transition-colors ${isActive(item) ? "bg-r24-red text-white" : "text-gray-300 hover:bg-white/10"}`}>
                <Icon size={18} /> {item.label}
              </Link>
            );
          })}
        </nav>
        <div className="p-3 border-t border-white/10 space-y-1">
          <div className="px-3 py-2 text-[11px] text-gray-400 truncate" data-testid="admin-current-email" title={user?.email}>
            Signed in as<br /><span className="text-white font-semibold">{user?.email}</span>
          </div>
          <Link to="/" target="_blank" className="flex items-center gap-3 px-3 py-2 text-gray-300 hover:text-white text-sm"><ExternalLink size={16} /> View Site</Link>
          <button onClick={() => { logout(); navigate("/admin/login"); }} data-testid="admin-logout" className="w-full flex items-center gap-3 px-3 py-2 text-gray-300 hover:text-r24-red text-sm font-semibold"><LogOut size={16} /> Sign Out</button>
        </div>
      </aside>
      <main className="flex-1 ml-60 p-6 md:p-8">
        <Outlet />
      </main>
    </div>
  );
}
